import { IconButton, Box } from '@mui/material';
import React, { FC, useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import HelperModal from '@acorn-portal/shared/src/components/modal/HelperModal';
import RadioButton from './radio-button';
import FormField from '@acorn-portal/shared/src/components/inputs/FormField';

interface IModal {
	title: string;
	description: string;
}

interface IProps {
	onChange: (value: string) => void;
	onblur?: (event: React.FocusEvent<HTMLInputElement>) => void;
	name?: string;
	id?: string;
	error?: boolean;
	helperText?: string | false;
	value?: unknown;
	label: string;
	modal?: IModal;
	subText?: React.ReactNode | string;
	topLabel?: boolean;
	className?: string;
}

const RadioGroupButton: FC<IProps> = ({
	error,
	helperText,
	id,
	label,
	modal,
	onChange,
	onblur,
	value,
	subText,
	name,
	topLabel,
	className,
}) => {
	const [open, toggleModal] = useState(false);

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		onChange(event.target.value);
	};

	return (
		<div className={className}>
			<FormField error={error} helperText={helperText} id={id} label={label} subText={subText} topLabel={topLabel}>
				<Box
					sx={(theme) => ({
						display: 'flex',
						'& label:first-of-type': {
							padding: theme.spacing(0, 1),
						},
						[theme.breakpoints.down('md')]: {
							justifyContent: 'space-evenly',
						},
					})}
				>
					<Box
						sx={{
							display: 'inherit',
							width: '100px',
						}}
					>
						<RadioButton
							id={`${id ?? ''} yes`}
							label='Yes'
							value='yes'
							onChange={handleChange}
							onBlur={onblur}
							selectedValue={value as string}
							error={error}
							name={name}
						/>
					</Box>
					<Box
						sx={{
							display: 'inherit',
							width: '100px',
						}}
					>
						<RadioButton
							id={`${id ?? ''} no`}
							label='No'
							value='no'
							onChange={handleChange}
							onBlur={onblur}
							selectedValue={value as string}
							error={error}
							name={name}
						/>
						{modal && (
							<IconButton
								color='icon'
								aria-label={`${id ?? ''}-more-info`}
								sx={(theme) => ({
									my: 1,
									height: '40px',
									margin: 'auto',
									[theme.breakpoints.down('md')]: {
										mx: theme.spacing(2),
										px: 0,
									},
								})}
								onClick={() => toggleModal(true)}
							>
								<InfoIcon />
							</IconButton>
						)}
					</Box>
				</Box>
			</FormField>
			{modal && <HelperModal onClose={() => toggleModal(false)} open={open} {...modal} />}
		</div>
	);
};

export default RadioGroupButton;
